module.exports = __webpack_public_path__ + "img/TADA.f74ac88e.webp";